import { render, staticRenderFns } from "./ResourceTopic.vue?vue&type=template&id=1bdac958&"
import script from "./ResourceTopic.vue?vue&type=script&lang=js&"
export * from "./ResourceTopic.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTopic.vue?vue&type=style&index=0&id=1bdac958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports